import React from 'react';
import { Box, Notification, NotificationType } from 'edenred-ui';
import { useFormContext, useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BenefitGroupTile, NotificationInfo } from '@epi-shared/components';
import { FormFields } from '@epi-forms/helpers';
import {
  IBenefitGroupSettings,
  IBenefits
} from '@epi-models/pages/Beneficiaries';

export const Benefits = ({ isAddMode = false }: IBenefits) => {
  const { control } = useFormContext();
  const { t } = useTranslation();

  const {
    field: { value: activeBenefits }
  } = useController({
    name: FormFields.Benefits,
    control
  });

  return (
    <Box mt={4} pb={0} id="employee-benefit-benefits-tab">
      {isAddMode && (
        <Box pb={2} pt={0}>
          <Notification
            type={NotificationType.Info}
            text={t(
              'containers.beneficiaries.add_employee.benefits_notification_text'
            )}
            id="employee-benefit-benefits-tab-notification-info"
          />
        </Box>
      )}
      <Box
        display="grid"
        gridTemplateColumns="repeat(auto-fit, minmax(296px, 1fr))"
        gap={2}
      >
        {activeBenefits.map((groupDetails: IBenefitGroupSettings, index) => (
          <BenefitGroupTile
            key={groupDetails.groupId}
            groupName={t(
              `components.manage_benefits.new.benefits.${groupDetails.benefitType.toLowerCase()}`
            )}
            maxAmountPerPeriod={groupDetails.maxAmountPerPeriod}
            index={index}
            noHover
            benefitType={groupDetails.benefitType.toLowerCase()}
          />
        ))}
      </Box>
    </Box>
  );
};
